import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import { ProviderType } from 'src/types/provider';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';
import { Typography, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export interface SlaPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ProviderType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
}

const Sla: FC<SlaPropsType> = (props) => {
    return (
        <>
            <Grid>
                <GridItem cols={3}>
                    <TextField
                        type={'time'}
                        value={props.editData.SLA_ALZA_SHIPPING}
                        error={props.editErrors.SLA_ALZA_SHIPPING}
                        onChange={(value, error) => props.onChange('SLA_ALZA_SHIPPING', value || null, error)}
                        name="SLA_ALZA_SHIPPING"
                        label={translate('providerDetail.slaAlzaShipping')}
                        fullWidth
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        value={props.editData.RECEIVING_POSTPONE_HOURS}
                        error={props.editErrors.RECEIVING_POSTPONE_HOURS}
                        onChange={(value, error) => props.onChange('RECEIVING_POSTPONE_HOURS', value || null, error)}
                        name="RECEIVING_POSTPONE_HOURS"
                        label={translate('providerDetail.receivingPostponeHours')}
                        fullWidth
                        type={'number'}
                        min={0}
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        type={'time'}
                        value={props.editData.B2C_SLA}
                        error={props.editErrors.B2C_SLA}
                        onChange={(value, error) => props.onChange('B2C_SLA', value || null, error)}
                        name="B2C_SLA"
                        label={translate('providerDetail.b2cSla')}
                        fullWidth
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        type={'time'}
                        value={props.editData.B2B_SLA}
                        error={props.editErrors.B2B_SLA}
                        onChange={(value, error) => props.onChange('B2B_SLA', value || null, error)}
                        name="B2B_SLA"
                        label={translate('providerDetail.b2bSla')}
                        fullWidth
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        value={props.editData.B2B_D0}
                        error={props.editErrors.B2B_D0}
                        onChange={(value, error) => props.onChange('B2B_D0', value || null, error)}
                        name="B2B_D0"
                        label={translate('providerDetail.b2bD0')}
                        fullWidth
                        min={0}
                        type={'number'}
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        value={props.editData.B2B_D1}
                        error={props.editErrors.B2B_D1}
                        onChange={(value, error) => props.onChange('B2B_D1', value || null, error)}
                        name="B2B_D1"
                        label={translate('providerDetail.b2bD1')}
                        fullWidth
                        min={0}
                        type={'number'}
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        value={props.editData.B2B_D2}
                        error={props.editErrors.B2B_D2}
                        onChange={(value, error) => props.onChange('B2B_D2', value || null, error)}
                        name="B2B_D2"
                        label={translate('providerDetail.b2bD2')}
                        fullWidth
                        min={0}
                        type={'number'}
                        disabled={props.disableEdit}
                    />
                </GridItem>
                <GridItem cols={3}>
                    <TextField
                        value={props.editData.B2B_D3}
                        error={props.editErrors.B2B_D3}
                        onChange={(value, error) => props.onChange('B2B_D3', value || null, error)}
                        name="B2B_D3"
                        min={0}
                        label={translate('providerDetail.b2bD3')}
                        fullWidth
                        type={'number'}
                        disabled={props.disableEdit}
                    />
                </GridItem>
            </Grid>
        </>
    );
};

export default Sla;
